<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            :title='invoices.title'
            :titleIcon='invoices.icon'
            :titleIconColor='invoices.iconColor'
            :showAdd='!project.archived && !project.on_hold'
            @add='addInvoice'
            showArchived
            :showArchivedStatus='showArchived'
            @toggleShowArchived='showArchived = !showArchived'
          >
            <template v-slot:toolbarButtons>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              :items='filteredInvoices'
              dense
              :search='search'
              :headers='formattedHeader'
              :items-per-page='-1'
              hide-default-footer
              @click:row='openInvoice'
            >
              <template v-slot:item.invoice_date='{ item }'>
                {{ item.invoice_date | shortDate }}
              </template>
               <template v-slot:item.number='{ item }'>
                {{ item.number }}
                <v-icon class='ml-2' v-if='item.archived' color='error'>mdi-archive</v-icon>
              </template>
                <template v-slot:item.status='{ item }'>
                  <status-chip :status='item.status' small></status-chip>
                </template>
              <template v-slot:item.original_amount='{ item }'>
                {{ item.original_amount | decMoney }}
              </template>
               <template v-slot:item.amount_os='{ item }'>
                {{ item.amount_os | decMoney }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <new-invoice-dialog
      :showDialog='showDialog'
      :invoice='newInvoice'
      @save='openInvoice'
      @cancel='showDialog = false'
      hideDivision
    ></new-invoice-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import accountingAPI from '@/api/accounting';
import StatusChip from '@/modules/accounting/components/invoice/StatusChip';
import NewInvoiceDialog from '@/modules/accounting/components/invoice/NewInvoiceDialog';
import moment from 'moment';

export default {
  name: 'project-invoices',
  props: {
    project: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    projectInvoices: [],
    search: '',
    showDialog: false,
    showArchived: false,
    newInvoice: {},
    headers: [
      { text: 'Invoice date', value: 'invoice_date' },
      { text: 'Number', value: 'number', align: 'start' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Bill to', value: 'bill_to_display', align: 'center' },
      { text: 'Original Amt', value: 'original_amount', align: 'end' },
      { text: 'Amount OS', value: 'amount_os', align: 'end' }
    ]
  }),
  computed: {
    formattedHeader () {
      let newHeader = this.headers
      for (let h in newHeader) {
        newHeader[h].class = 'overline'
      }
      return newHeader
    },
    filteredInvoices () {
      if (this.showArchived) {
        return this.projectInvoices
      }
      return this.projectInvoices.filter(i => i.archived === false)
    },
    ...mapState({
      invoices: state => state.icons.dataBox.invoices
    })
  },
  mounted () {
    this.getInvoices()
  },
  methods: {
    async getInvoices () {
      this.isLoading = true
      this.projectInvoices = await accountingAPI.getProjectInvoices(this.project.id)
      this.isLoading = false
    },
    openInvoice (invoice) {
      this.$router.push({ name: 'InvoiceOverview', params: { id: invoice.id } })
    },
    addInvoice () {
      this.newInvoice.division = this.project.division
      this.newInvoice.bill_to = this.project.bill_to
      this.newInvoice.project = this.project.id
      this.newInvoice.invocie_date = moment().format('YYYY-MM-DD').toString()
      this.newInvoice.terms = this.project.division_obj.terms
      this.newInvoice.interest = this.project.division_obj.interest
      this.showDialog = true
    }
  },
  components: {
    'status-chip': StatusChip,
    'new-invoice-dialog': NewInvoiceDialog
  }
}
</script>
